import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'

export default function SingleSelect(props) {

    const { label_name, placeholder, disabled,formatOptionLabel, closeMenu, option, name, defaultValue, onChange, onBlur, error, loading, reference, onInputChange, form_group, clear, mandatory, customOption, value, tabIndex } = props

    return (
        <>
            <Form.Group className={form_group ? form_group : "mb-2"} controlId="">
                {label_name == '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{label_name}</Form.Label>}
                <Select
                    ref={reference}
                    closeMenuOnSelect={closeMenu}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    options={option}
                    className='react_select'
                    classNamePrefix="select"
                    name={name}
                    defaultValue={defaultValue}
                    value={value}
                    onChange={onChange}
                    onInputChange={onInputChange}
                    onBlur={onBlur}
                    isLoading={loading}
                    isClearable={clear}
                    components={customOption}
                    tabIndex={tabIndex}
                    formatOptionLabel={formatOptionLabel}

                    styles={{
                        control: (provided, state) =>
                        ({
                            ...provided,
                            minHeight: 'inherit',
                            height: '31px',
                            borderTop: 'none',
                            borderLeft: 'none',
                            borderRight: 'none',
                            borderRadius: 'none',
                            // borderWidth: '1.5px',
                            fontSize: '14px',
                            padding: '0px',
                            "&:focus-within": {
                                borderColor: "#032d42",
                                boxShadow: "none",
                            },
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            fontWeight: state.isSelected ? 'bold' : 'normal',
                            fontSize: '14px',
                            color: 'black',
                            padding: '5px 12px',
                            borderRadius: '4px',
                            fontFamily: 'Lexend Deca'
                        }),
                        menu: (provided) => ({
                            ...provided,
                            padding: '1px 4px',
                            borderRadius: '4px',
                            zIndex: 9999 // Adjust the value as needed
                        }),
                    }}

                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                            ...theme.colors,
                            primary25: 'rgba(0,0,0,0.04)',
                            primary50: '#e6f4ff',
                            primary: '#e6f4ff',
                        },
                    })}
                />
                {error}
            </Form.Group>
        </>
    )
}
